import React from 'react';
import './Projects.css';
import ProjectCard from './ProjectCard';
import portfolioImage from '../../assets/projectImages/portfolioImage.jpg';
import investmentCalculatorImage from '../../assets/projectImages/investmentCalculatorImage.jpg';
import foodOrderImage from '../../assets/projectImages/foodOrderAppImage.jpg';
import learnExerciseAppImage from '../../assets/projectImages/learnExerciseAppImage.jpg';
import thrivehivesImage from '../../assets/projectImages/thrivehivesImage.jpg';
import peaceTrailImage from '../../assets/projectImages/peaceTrailImage.jpeg'
import Heading from '../UI/Heading'
import ModifiedButton02 from '../UI/ModifiedButton02';
import { FaReact, FaNodeJs, FaDatabase } from 'react-icons/fa';
import { SiExpress, SiSupabase, SiMongodb } from 'react-icons/si';

function Projects() {
  const projects = [
    {
      type: "web",
      heading: "Peace Trail Tour & Travel",
      image: peaceTrailImage,
      description: "Tour package booking website for a holiday and tour agency where users can explore and book packages. AI powered recommendation system for personalized suggestions, along with OTP verified booking. The Trouvaille chatbot handles end-to-end booking, previous bookings, and feedback. A complete MERN Stack project, with Google Sheet and GPA used to store and access package data.",
      technologies: [
        { name: 'React', icon: <FaReact /> },
        { name: 'Node.js', icon: <FaNodeJs /> },
        { name: 'Express', icon: <SiExpress /> },
        { name: 'MongoDB', icon: <SiMongodb /> }
      ],
      code: "https://github.com/rahulkundu1209/peacetrail-travel-tourism.git",
      demo: "https://peacetrail.vercel.app/"
    },
    {
      type: "web",
      heading: "Thrive Hives",
      image: thrivehivesImage,
      description: "A comprehensive web platform designed to provide essential tools and resources to students enrolled in the Thrive Hives course. Features include course materials, progress tracking, and collaborative tools to enhance the learning experience.",
      technologies: [
        { name: 'React', icon: <FaReact /> },
        { name: 'Node.js', icon: <FaNodeJs /> },
        { name: 'Express', icon: <SiExpress /> },
        { name: 'Supabase', icon: <SiSupabase /> }
      ],
      code: "https://github.com/rahulkundu1209/ThriveHive-web",
      demo: "https://thrive-hives.vercel.app/"
    },
    {
      type: "web",
      heading: "Learn Exercise App",
      image: learnExerciseAppImage,
      description: "A feature-rich fitness web application that allows users to search for exercises by name or target body part. Includes user authentication for bookmarking favorite exercises, detailed exercise instructions, and a personalized workout tracking system.",
      technologies: [
        { name: 'React', icon: <FaReact /> },
        { name: 'Firebase', icon: <FaDatabase /> }
      ],
      code: "https://github.com/rahulkundu1209/learn-exercises.git",
      demo: "https://learn-exercises-beb83.web.app/"
    },
    {
      type: "web",
      heading: "Portfolio Website",
      image: portfolioImage,
      description: "A modern, responsive single-page portfolio website showcasing professional skills, projects, and contact information. Features smooth animations, interactive components, and optimized performance for an engaging user experience.",
      technologies: [
        { name: 'React', icon: <FaReact /> }
      ],
      code: "https://github.com/rahulkundu1209/portfolio",
      demo: "https://rahulkundu1209.github.io/portfolio"
    },
    {
      type: "web",
      heading: "Investment Calculator",
      image: investmentCalculatorImage,
      description: "A powerful financial planning tool that calculates compound interest, yearly returns, and total investment growth. Features interactive inputs, real-time calculations, and visual representation of investment projections over time.",
      technologies: [
        { name: 'React', icon: <FaReact /> }
      ],
      code: "https://github.com/rahulkundu1209/investment-calculator",
      demo: "https://rahulkundu1209.github.io/investment-calculator/",
    },
    {
      type: "web",
      heading: "Food Order App",
      image: foodOrderImage,
      description: "An intuitive restaurant food ordering application with a clean interface for browsing menu items, adding items to cart, and managing orders. Currently integrating backend functionality for a complete ordering system.",
      technologies: [
        { name: 'React', icon: <FaReact /> }
      ],
      code: "https://github.com/rahulkundu1209",
      demo: ""
    },
  ]

  return (
    <section id='projects'>
        <Heading content = "PROJECTS" fontSize="30px" className="projects-heading"/>
        <div className='projects-subheading'>
            <ModifiedButton02>WEB</ModifiedButton02>
        </div>
        <div className='projects-contents'>
            <div className='web-projects-content'>
              {projects.map(project => (
                <ProjectCard
                key={project.heading}
                heading={project.heading}
                image = {project.image}
                description = {project.description}
                technologies = {project.technologies}
                codeLink = {project.code}
                demoLink = {project.demo}
                />
              ))}
            </div>
        </div>
    </section>
  )
}

export default Projects;
